import { Component } from '@verndale/core';
import { mediaQuery } from '../helpers/media-queries';

class VariantsTable extends Component {
  mq: MediaQueryList;
  rows: HTMLElement[][];

  constructor(el: HTMLElement) {
    super(el);
    this.mq = mediaQuery('tabletLandscape');
    this.rows = [];
    this.addListeners();
    this.initRows();
  }

  setupDefaults() {
    this.dom = {
      ths: this.el.querySelectorAll('th'),
      tds: this.el.querySelectorAll('td'),
      links: this.el.querySelectorAll('.link'),
      tableBody: this.el.querySelector<HTMLElement>('.table__body'),
      tableHead: this.el.querySelector<HTMLElement>('.table__head'),
      tableWrapper: this.el.querySelector<HTMLElement>('.table__wrapper'),
      scrollLeftButton: this.el.querySelector<HTMLElement>('.table__button-left'),
      scrollRightButton: this.el.querySelector<HTMLElement>('.table__button-right')
    };
  }

  addListeners() {
    this.mq?.addEventListener('change', this.initRows.bind(this));
    (this.dom.links as NodeList)?.forEach(link =>
      link.addEventListener('click', this.handleClick.bind(this))
    );
    (this.dom.scrollLeftButton as HTMLButtonElement)?.addEventListener('click', () => {
      (this.dom.tableWrapper as HTMLElement).scrollBy({ left: -100, behavior: 'smooth' });
    });

    (this.dom.scrollRightButton as HTMLButtonElement)?.addEventListener('click', () => {
      (this.dom.tableWrapper as HTMLElement).scrollBy({ left: 100, behavior: 'smooth' });
    });
  }

  handleClick(event: Event) {
    event.preventDefault();
    const target = (event.target as HTMLElement).closest('a');
    const id = (target as HTMLElement)?.dataset.id;
    const section = document.querySelector(`#${id}`);
    const select = document.querySelector('.request-a-quote__select') as HTMLSelectElement;
    const sku = (target as HTMLElement).dataset.sku;

    if (id) {
      if (section) {
        window.scrollTo({
          top: section.getBoundingClientRect().top + window.scrollY - 100,
          behavior: 'smooth'
        });

        if (select && sku) {
          select.value = sku;
        }
      }
    } else {
      window.location.href = (target as HTMLElement).getAttribute('href') as string;
    }

    //   add the id to the url
    if (history.pushState && id) {
      history.pushState(null, '', `#${id}`);
    }
  }

  initRows() {
    const tableHead = this.dom.tableHead as HTMLElement;
    const tableBody = this.dom.tableBody as HTMLElement;

    if (!this.mq.matches) {
      (this.dom.ths as NodeList).forEach((th, i) => {
        const tds = this.el.querySelectorAll(`td:nth-child(${i + 1})`);
        this.rows.push(this.initRow(th as HTMLElement, tds));
      });

      this.rows.forEach(row => {
        this.setRowHeight(row);
      });

      tableBody.style.paddingInlineStart = `${tableHead.offsetWidth}px`;

    } else {
      (this.dom.ths as NodeList).forEach(th => {
        (th as HTMLElement).style.height = '';
      });
      (this.dom.tds as NodeList).forEach(td => {
        (td as HTMLElement).style.height = '';
      });

      tableBody.style.paddingInlineStart = '';
    }
  }

  initRow(th: HTMLElement, tds: NodeList) {
    const row = [];
    row.push(th);
    (tds as NodeList).forEach(td => {
      row.push(td);
    });

    return row;
  }

  setRowHeight(row: HTMLElement[]) {
    let maxHeight = 0;
    row.forEach(td => {
      const height = (td as HTMLElement).offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    row.forEach(td => {
      (td as HTMLElement).style.height = `${maxHeight}px`;
    });
  }
}

export default VariantsTable;
